import { createFileRoute, Outlet } from '@tanstack/react-router';

import { requireOnboarding } from '../features/onboarding/require-onboarding';

/**
 * `/mylab` 하위 전체의 공유 게이트 — 로그인 게이트의 도착지다 (E14 §2).
 *
 * 순수 레이아웃이다: `/mylab`(S4 오늘)과 `/mylab/lab-log`(S20)는 서로의 화면을 감싸지 않는
 * 독립된 화면이라 각자 `mylab/index.tsx` · `mylab/lab-log.tsx`에 있다.
 */
export const Route = createFileRoute('/mylab')({
  beforeLoad: ({ context, location }) =>
    requireOnboarding({ queryClient: context.queryClient, location }),
  component: Outlet,
});
